import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { emptyArray } from 'ui-components/default-props/empty';
import { WAREHOUSE_SETTINGS_URL } from '../../../pages/settings/ship-from-locations/constants';
import messages from '../../../ship-from/components/messages';
import { useExistingShipFromRequiresEmail } from '../../../ship-from/hooks/use-requires-email';
import Global from '../../../store/global-selectors';

export const ShipFromErrorBanner = ({ fulfillmentPlanIds }) => {
  const fulfillmentPlans = useSelector((state) => Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds })) || emptyArray;
  const shipFroms = useSelector(Global.selectSellerShipFroms) || emptyArray;
  const defaultShipFromId = useSelector(Global.selectSellerDefaultShipFromId);
  const shipFromIds = fulfillmentPlans.map((plan) => plan.shipFromId);
  if (shipFromIds.length === 0) {
    shipFromIds.push(defaultShipFromId);
  }
  const selectedShipFroms = shipFroms.filter((sf) => shipFromIds.includes(sf.shipFromId));
  const emailIsRequired = useExistingShipFromRequiresEmail(selectedShipFroms);
  if (!emailIsRequired) {
    return null;
  }
  return (
    <BannerMessageV2
      content={
        <FormattedMessage
          {...messages.shipFromErrorMessage}
          values={{
            link: (text) => (
              <Link
                to={{
                  pathname: WAREHOUSE_SETTINGS_URL,
                  state: WAREHOUSE_SETTINGS_URL,
                }}
              >
                {text}
              </Link>
            ),
          }}
        />
      }
      status={BannerStatus.Error}
    />
  );
};

ShipFromErrorBanner.propTypes = {
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};
